// extracted by mini-css-extract-plugin
module.exports = {"highlight":"ProHighlight_highlight__Wsfa7"};